import { textSm } from '@insify/design-system/typography';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './NoResult.module.css';

export const NoResult = (): JSX.Element => {
  const { t } = useTranslation(['funnel']);

  return (
    <div className={styles.noResult}>
      <div className={clsx(styles.header, textSm)}>{t('funnel:company_no_result_header')}</div>
    </div>
  );
};
